export const SET_ERROR_COMMON = 'errors.SET_ERROR_COMMON';